"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(_getMatchingTypes);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
function _export(target, all) {
  for (var name in all) {
    Object.defineProperty(target, name, {
      enumerable: true,
      get: all[name]
    });
  }
}
_export(exports, {
  updateAllClasses: function updateAllClasses() {
    return _updateAllClasses;
  },
  filterSelectorsForClass: function filterSelectorsForClass() {
    return _filterSelectorsForClass;
  },
  asValue: function asValue() {
    return _asValue;
  },
  parseColorFormat: function parseColorFormat() {
    return _parseColorFormat;
  },
  asColor: function asColor() {
    return _asColor;
  },
  asLookupValue: function asLookupValue() {
    return _asLookupValue;
  },
  typeMap: function typeMap() {
    return _typeMap;
  },
  coerceValue: function coerceValue() {
    return _coerceValue;
  },
  getMatchingTypes: function getMatchingTypes() {
    return _getMatchingTypes;
  }
});
var _postcssSelectorParser = /*#__PURE__*/_interopRequireDefault(require("postcss-selector-parser"));
var _escapeCommas = /*#__PURE__*/_interopRequireDefault(require("./escapeCommas"));
var _withAlphaVariable = require("./withAlphaVariable");
var _dataTypes = require("./dataTypes");
var _negateValue = /*#__PURE__*/_interopRequireDefault(require("./negateValue"));
var _validateFormalSyntax = require("./validateFormalSyntax");
var _featureFlagsJs = require("../featureFlags.js");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _updateAllClasses(selectors, updateClass) {
  var parser = (0, _postcssSelectorParser.default)(function (selectors) {
    selectors.walkClasses(function (sel) {
      var updatedClass = updateClass(sel.value);
      sel.value = updatedClass;
      if (sel.raws && sel.raws.value) {
        sel.raws.value = (0, _escapeCommas.default)(sel.raws.value);
      }
    });
  });
  var result = parser.processSync(selectors);
  return result;
}
function _filterSelectorsForClass(selectors, classCandidate) {
  var parser = (0, _postcssSelectorParser.default)(function (selectors) {
    selectors.each(function (sel) {
      var containsClass = sel.nodes.some(function (node) {
        return node.type === "class" && node.value === classCandidate;
      });
      if (!containsClass) {
        sel.remove();
      }
    });
  });
  var result = parser.processSync(selectors);
  return result;
}
function resolveArbitraryValue(modifier, validate) {
  if (!isArbitraryValue(modifier)) {
    return undefined;
  }
  var value = modifier.slice(1, -1);
  if (!validate(value)) {
    return undefined;
  }
  return (0, _dataTypes.normalize)(value);
}
function asNegativeValue(modifier) {
  var lookup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var validate = arguments.length > 2 ? arguments[2] : undefined;
  var positiveValue = lookup[modifier];
  if (positiveValue !== undefined) {
    return (0, _negateValue.default)(positiveValue);
  }
  if (isArbitraryValue(modifier)) {
    var resolved = resolveArbitraryValue(modifier, validate);
    if (resolved === undefined) {
      return undefined;
    }
    return (0, _negateValue.default)(resolved);
  }
}
function _asValue(modifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {
      return true;
    } : _ref$validate;
  var ref;
  var value = (ref = options.values) === null || ref === void 0 ? void 0 : ref[modifier];
  if (value !== undefined) {
    return value;
  }
  if (options.supportsNegativeValues && modifier.startsWith("-")) {
    return asNegativeValue(modifier.slice(1), options.values, validate);
  }
  return resolveArbitraryValue(modifier, validate);
}
function isArbitraryValue(input) {
  return input.startsWith("[") && input.endsWith("]");
}
function splitUtilityModifier(modifier) {
  var slashIdx = modifier.lastIndexOf("/");
  if (slashIdx === -1 || slashIdx === modifier.length - 1) {
    return [modifier, undefined];
  }
  var arbitrary = isArbitraryValue(modifier);
  // The modifier could be of the form `[foo]/[bar]`
  // We want to handle this case properly
  // without affecting `[foo/bar]`
  if (arbitrary && !modifier.includes("]/[")) {
    return [modifier, undefined];
  }
  return [modifier.slice(0, slashIdx), modifier.slice(slashIdx + 1)];
}
function _parseColorFormat(value) {
  if (typeof value === "string" && value.includes("<alpha-value>")) {
    var oldValue = value;
    return function (_ref2) {
      var _ref2$opacityValue = _ref2.opacityValue,
        opacityValue = _ref2$opacityValue === void 0 ? 1 : _ref2$opacityValue;
      return oldValue.replace("<alpha-value>", opacityValue);
    };
  }
  return value;
}
function _asColor(_) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$tailwindConfig = _ref3.tailwindConfig,
    tailwindConfig = _ref3$tailwindConfig === void 0 ? {} : _ref3$tailwindConfig,
    utilityModifier = _ref3.utilityModifier,
    rawModifier = _ref3.rawModifier;
  var ref;
  if (((ref = options.values) === null || ref === void 0 ? void 0 : ref[rawModifier]) !== undefined) {
    var ref1;
    return _parseColorFormat((ref1 = options.values) === null || ref1 === void 0 ? void 0 : ref1[rawModifier]);
  }
  // TODO: Hoist this up to getMatchingTypes or something
  // We do this here because we need the alpha value (if any)
  var _splitUtilityModifier = splitUtilityModifier(rawModifier),
    _splitUtilityModifier2 = _slicedToArray(_splitUtilityModifier, 2),
    color = _splitUtilityModifier2[0],
    alpha = _splitUtilityModifier2[1];
  if (alpha !== undefined) {
    var ref2, ref3, ref4;
    var ref5;
    var normalizedColor = (ref5 = (ref2 = options.values) === null || ref2 === void 0 ? void 0 : ref2[color]) !== null && ref5 !== void 0 ? ref5 : isArbitraryValue(color) ? color.slice(1, -1) : undefined;
    if (normalizedColor === undefined) {
      return undefined;
    }
    normalizedColor = _parseColorFormat(normalizedColor);
    if (isArbitraryValue(alpha)) {
      return (0, _withAlphaVariable.withAlphaValue)(normalizedColor, alpha.slice(1, -1));
    }
    if (((ref3 = tailwindConfig.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.opacity) === null || ref4 === void 0 ? void 0 : ref4[alpha]) === undefined) {
      return undefined;
    }
    return (0, _withAlphaVariable.withAlphaValue)(normalizedColor, tailwindConfig.theme.opacity[alpha]);
  }
  return _asValue(rawModifier, options, {
    rawModifier: rawModifier,
    utilityModifier: utilityModifier,
    validate: _dataTypes.color
  });
}
function _asLookupValue(modifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ref;
  return (ref = options.values) === null || ref === void 0 ? void 0 : ref[modifier];
}
function guess(validate) {
  return function (modifier, options, extras) {
    return _asValue(modifier, options, _objectSpread(_objectSpread({}, extras), {}, {
      validate: validate
    }));
  };
}
var _typeMap = {
  any: _asValue,
  color: _asColor,
  url: guess(_dataTypes.url),
  image: guess(_dataTypes.image),
  length: guess(_dataTypes.length),
  percentage: guess(_dataTypes.percentage),
  position: guess(_dataTypes.position),
  lookup: _asLookupValue,
  "generic-name": guess(_dataTypes.genericName),
  "family-name": guess(_dataTypes.familyName),
  number: guess(_dataTypes.number),
  "line-width": guess(_dataTypes.lineWidth),
  "absolute-size": guess(_dataTypes.absoluteSize),
  "relative-size": guess(_dataTypes.relativeSize),
  shadow: guess(_dataTypes.shadow),
  size: guess(_validateFormalSyntax.backgroundSize)
};
var supportedTypes = Object.keys(_typeMap);
function splitAtFirst(input, delim) {
  var idx = input.indexOf(delim);
  if (idx === -1) return [undefined, input];
  return [input.slice(0, idx), input.slice(idx + 1)];
}
function _coerceValue(types, modifier, options, tailwindConfig) {
  if (isArbitraryValue(modifier)) {
    var arbitraryValue = modifier.slice(1, -1);
    var _splitAtFirst = splitAtFirst(arbitraryValue, ":"),
      _splitAtFirst2 = _slicedToArray(_splitAtFirst, 2),
      explicitType = _splitAtFirst2[0],
      value = _splitAtFirst2[1];
    // It could be that this resolves to `url(https` which is not a valid
    // identifier. We currently only support "simple" words with dashes or
    // underscores. E.g.: family-name
    if (!/^[\w-_]+$/g.test(explicitType)) {
      value = arbitraryValue;
    } else if (explicitType !== undefined && !supportedTypes.includes(explicitType)) {
      return [];
    }
    if (value.length > 0 && supportedTypes.includes(explicitType)) {
      return [_asValue("[".concat(value, "]"), options), explicitType, null];
    }
  }
  var matches = _getMatchingTypes(types, modifier, options, tailwindConfig);
  // Find first matching type
  var _iterator = _createForOfIteratorHelper(matches),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var match = _step.value;
      return match;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [];
}
function _getMatchingTypes(types, rawModifier, options, tailwindConfig) {
  var modifiersEnabled, _splitUtilityModifier3, _splitUtilityModifier4, modifier, utilityModifier, canUseUtilityModifier, ref, ref1, configValue, result, _iterator2, _step2, type, result1;
  return _regeneratorRuntime().wrap(function _getMatchingTypes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          modifiersEnabled = (0, _featureFlagsJs.flagEnabled)(tailwindConfig, "generalizedModifiers");
          _splitUtilityModifier3 = splitUtilityModifier(rawModifier), _splitUtilityModifier4 = _slicedToArray(_splitUtilityModifier3, 2), modifier = _splitUtilityModifier4[0], utilityModifier = _splitUtilityModifier4[1];
          canUseUtilityModifier = modifiersEnabled && options.modifiers != null && (options.modifiers === "any" || typeof options.modifiers === "object" && (utilityModifier && isArbitraryValue(utilityModifier) || utilityModifier in options.modifiers));
          if (!canUseUtilityModifier) {
            modifier = rawModifier;
            utilityModifier = undefined;
          }
          if (utilityModifier !== undefined && modifier === "") {
            modifier = "DEFAULT";
          }
          // Check the full value first
          // TODO: Move to asValue… somehow
          if (!(utilityModifier !== undefined)) {
            _context.next = 11;
            break;
          }
          if (typeof options.modifiers === "object") {
            configValue = (ref1 = (ref = options.modifiers) === null || ref === void 0 ? void 0 : ref[utilityModifier]) !== null && ref1 !== void 0 ? ref1 : null;
            if (configValue !== null) {
              utilityModifier = configValue;
            } else if (isArbitraryValue(utilityModifier)) {
              utilityModifier = utilityModifier.slice(1, -1);
            }
          }
          result = _asValue(rawModifier, options, {
            rawModifier: rawModifier,
            utilityModifier: utilityModifier,
            tailwindConfig: tailwindConfig
          });
          if (!(result !== undefined)) {
            _context.next = 11;
            break;
          }
          _context.next = 11;
          return [result, "any", null];
        case 11:
          _iterator2 = _createForOfIteratorHelper(types !== null && types !== void 0 ? types : []);
          _context.prev = 12;
          _iterator2.s();
        case 14:
          if ((_step2 = _iterator2.n()).done) {
            _context.next = 23;
            break;
          }
          type = _step2.value.type;
          result1 = _typeMap[type](modifier, options, {
            rawModifier: rawModifier,
            utilityModifier: utilityModifier,
            tailwindConfig: tailwindConfig
          });
          if (!(result1 === undefined)) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("continue", 21);
        case 19:
          _context.next = 21;
          return [result1, type, utilityModifier !== null && utilityModifier !== void 0 ? utilityModifier : null];
        case 21:
          _context.next = 14;
          break;
        case 23:
          _context.next = 28;
          break;
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](12);
          _iterator2.e(_context.t0);
        case 28:
          _context.prev = 28;
          _iterator2.f();
          return _context.finish(28);
        case 31:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[12, 25, 28, 31]]);
}